import i18n from '@/shared/i18n';

/** Populated dental chair from API, or legacy/null. */
export type DentalChairRef =
  | string
  | {
      _id?: string;
      id?: string;
      name?: string;
      code?: string;
    }
  | null
  | undefined;

const OBJECT_ID_RE = /^[a-f\d]{24}$/i;

export const getChairId = (value: DentalChairRef): string => {
  if (value == null) return '';
  if (typeof value === 'string') return value;
  return String(value.id || value._id || '');
};

export const getChairLabel = (value: DentalChairRef): string => {
  if (value == null || value === '') {
    return i18n.t('appointment:fallbacks.notAvailable');
  }
  if (typeof value === 'object') {
    if (value.name?.trim()) return value.name.trim();
    return i18n.t('appointment:fallbacks.notAvailable');
  }
  if (OBJECT_ID_RE.test(value)) {
    return i18n.t('appointment:fallbacks.notAvailable');
  }
  return value;
};
